import React, { useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import FormCanchas from "../../components/canchas/FormCanchas";
import Loader from "../../components/Loader";
import { useParams, useNavigate } from 'react-router-dom';
import useCanchasStore from "../../store/canchasStore";

const DetalleCancha = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { isLoading, actualizarId, iniciar, setNavigate, limpiar } = useCanchasStore();

  useEffect(() => {
    limpiar();
    setNavigate(navigate);
    actualizarId(id);
    iniciar();
  }, [id]);

  return (
    <>
      <MasterLayout>
        { (isLoading.cargarSucursalCategoria || isLoading.cargarCancha) ? 
          <Loader /> : 
          <FormCanchas/>
        }
      </MasterLayout>
    </>
  );
};

export default DetalleCancha;
